import * as PLAYBACKS from '@hotjar/recordings/src/constants/routes/playbacks';
import * as ENGAGE_INSIGHTS from '@hotjar/route-config';
import * as AUTH from './auth';
import * as API from './api';
import * as FEEDBACK from './feedback';
import * as PROFILE from './profile';
import * as SSO from './sso';
import * as TEAM from './team';
import * as OVERVIEW from './overview';
import * as DASHBOARD_QUANTZ from './dashboard-quantz';
import * as HEATMAPS from './heatmaps';
import * as ONBOARDING from './onboarding';
import * as SETTINGS from './settings';
import * as STATUS from './status';
import * as HIGHLIGHTS from './highlights';
import * as SITE from './site';
import * as SURVEYS from './surveys';
import * as MFA from './mfa';
import * as PERMISSION_REQUIRED from './permission-required';
import * as CHECKOUT from './checkout';
import * as TRENDS from './trends';
import * as FUNNELS from './funnels';
import * as SURVEY_TEMPLATES from './survey-templates';
import * as RECRUIT from './recruit';
import * as REGISTER from './register';
import * as INVITE_TEAMMATE from './invite-teammate';

export { AUTH };

export { API };

export { FEEDBACK };

export { PROFILE };

export { SSO };

export { TEAM };

export { OVERVIEW };

export { DASHBOARD_QUANTZ };

export { HEATMAPS };

export { MFA };

export { ONBOARDING };

export { SETTINGS };

export { STATUS };

export { HIGHLIGHTS };

export { PLAYBACKS };

export { SITE };

export { SURVEYS };

export { PERMISSION_REQUIRED };

export { CHECKOUT };

export { TRENDS };

export { FUNNELS };

export { SURVEY_TEMPLATES };

export { RECRUIT };

export { REGISTER };

export { ENGAGE_INSIGHTS };

export { INVITE_TEAMMATE };

// An array of all the routing config objects.
// This is to make it easier to search the configs from routing utils.
export const ALL_ROUTES = [
  ...Object.values(AUTH),
  ...Object.values(API),
  ...Object.values(FEEDBACK),
  ...Object.values(PROFILE),
  ...Object.values(SSO),
  ...Object.values(TEAM),
  ...Object.values(OVERVIEW),
  ...Object.values(DASHBOARD_QUANTZ),
  ...Object.values(HEATMAPS),
  ...Object.values(MFA),
  ...Object.values(ONBOARDING),
  ...Object.values(SETTINGS),
  ...Object.values(STATUS),
  ...Object.values(HIGHLIGHTS),
  ...Object.values(PLAYBACKS),
  ...Object.values(SITE),
  ...Object.values(SURVEYS),
  ...Object.values(PERMISSION_REQUIRED),
  ...Object.values(CHECKOUT),
  ...Object.values(TRENDS),
  ...Object.values(FUNNELS),
  ...Object.values(SURVEY_TEMPLATES),
  ...Object.values(RECRUIT),
  ...Object.values(ENGAGE_INSIGHTS),
  ...Object.values(INVITE_TEAMMATE),
];
